/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Product_Leveling_Config_WriteInputs */



/**
* | output |
* | --- |
* | "Configure levelling, perks and cards" |
*
* @param {Perm_Product_Leveling_Config_WriteInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_product_leveling_config_write = /** @type {((inputs?: Perm_Product_Leveling_Config_WriteInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Product_Leveling_Config_WriteInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настраивать уровни, привилегии и карточки")
	return /** @type {LocalizedString} */ ("Configure levelling, perks and cards")
});